import AccountTreeIcon from '@mui/icons-material/AccountTree'
import DateRangeIcon from '@mui/icons-material/DateRange'
import EventIcon from '@mui/icons-material/Event'
import EventBusyIcon from '@mui/icons-material/EventBusy'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import { PERM_LOG, PERM_PLANNING_EDIT, PERM_PLANNING_INDISPO } from '../utils/permissions'
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'
import { buildPageTitle } from '../utils/pageTitle'

export const ROUTE_LOGIN = '/login'
export const ROUTE_AUTH_CALLBACK = '/auth/callback'

export const ROUTE_DAY_VIEW_HEADLESS =
  '/Cy6rqPnVEV4HbschzefGjPT0tNJ6MHsGvPIS4Va2kV+AI24hEJPBXClZ9+tEwBXr+TRc5NVpforZI0JzujUAfzef'

export const ROUTE_GENERATEUR = '/generateur'
export const ROUTE_INDISPO = '/indispo'
export const ROUTE_DAY_VIEW = '/jour'
export const ROUTE_WEEK_VIEW = '/semaine'
export const ROUTE_SIGN_OUT = '/sign-out'
export const ROUTE_INDISPO_ASK = '/demandes-indispo'
export const ROUTE_LOGS = '/logs'
export const ROUTE_USERS_ADMIN = '/utilisateurs'
export const ROUTE_INDISPO_MANAGEMENT = '/gestion-indispo'
export const ROUTE_ADDITIONAL_SALES = '/ventes-additionnelles'
export const ROUTE_ELUCEO = '/eluceo'

export const ALL_PAGES = [
  {
    title: 'Jour',
    perms: [],
    path: ROUTE_DAY_VIEW,
    icon: <EventIcon />,
  },
  {
    title: 'Semaine',
    perms: [],
    path: ROUTE_WEEK_VIEW,
    icon: <DateRangeIcon />,
  },
  {
    title: 'Générateur',
    perms: [PERM_PLANNING_EDIT],
    path: ROUTE_GENERATEUR,
    icon: <AccountTreeIcon />,
  },
  {
    title: 'Indispo',
    perms: [PERM_PLANNING_INDISPO],
    path: ROUTE_INDISPO,
    icon: <EventBusyIcon />,
  },
  {
    title: 'Demande indispo',
    perms: [],
    path: ROUTE_INDISPO_ASK,
    icon: <QuestionAnswerIcon />,
  },
  {
    title: 'Logs',
    perms: [PERM_LOG],
    path: ROUTE_LOGS,
    icon: <MonitorHeartIcon />,
  },
  {
    title: 'Utilisateurs',
    perms: [PERM_LOG],
    path: ROUTE_USERS_ADMIN,
    icon: <PeopleAltIcon />,
  },
]

const STANDALONE_PAGE_TITLES = {
  '/': 'Planning',
  [ROUTE_LOGIN]: 'Planning',
  [ROUTE_AUTH_CALLBACK]: 'Connexion',
  [ROUTE_SIGN_OUT]: 'Déconnexion',
  [ROUTE_DAY_VIEW_HEADLESS]: 'Jour',
  [ROUTE_ADDITIONAL_SALES]: 'Ventes additionnelles',
  [ROUTE_ELUCEO]: 'Eluceo',
}

export const getPageTitleForPathname = (pathname) => {
  const page = ALL_PAGES.find((p) => p.path === pathname)

  return buildPageTitle(page?.title || STANDALONE_PAGE_TITLES[pathname] || 'Page introuvable')
}
